"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-monitor/testing/mock-credit-pull-response.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-monitor%2Ftesting%2Fmock-credit-pull-response.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockCreditPullResponse = void 0;
const credit_bureau_1 = require("../../common/credit-bureau");
const credit_pull_status_1 = require("../credit-pull-status");
const score_factors_1 = require("../score-factors");
const score_model_1 = require("../score-model");
const protobufPackage = 'com.step.creditmonitor.testing.proto';
function createBaseMockCreditPullResponse() {
    return {
        bureau: credit_bureau_1.CreditBureau.INVALID_CREDIT_BUREAU,
        status: credit_pull_status_1.CreditPullStatus.INVALID_CREDIT_PULL_STATUS,
        score: 0,
        scoreModel: score_model_1.ScoreModel.INVALID_SCORE_MODEL,
        scoreFactors: undefined,
        simulateInternalError: false,
    };
}
exports.MockCreditPullResponse = {
    fromJSON(object) {
        const message = {
            bureau: isSet(object.bureau)
                ? (0, credit_bureau_1.creditBureauFromJSON)(object.bureau)
                : credit_bureau_1.CreditBureau.INVALID_CREDIT_BUREAU,
        };
        if (isSet(object.status)) {
            message.status = (0, credit_pull_status_1.creditPullStatusFromJSON)(object.status);
        }
        if (isSet(object.score)) {
            message.score = globalThis.Number(object.score);
        }
        if (isSet(object.scoreModel)) {
            message.scoreModel = (0, score_model_1.scoreModelFromJSON)(object.scoreModel);
        }
        if (isSet(object.scoreFactors)) {
            message.scoreFactors = score_factors_1.ScoreFactors.fromJSON(object.scoreFactors);
        }
        if (isSet(object.simulateInternalError)) {
            message.simulateInternalError = globalThis.Boolean(object.simulateInternalError);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bureau !== credit_bureau_1.CreditBureau.INVALID_CREDIT_BUREAU) {
            obj.bureau = (0, credit_bureau_1.creditBureauToJSON)(message.bureau);
        }
        if (message.status !== undefined && message.status !== credit_pull_status_1.CreditPullStatus.INVALID_CREDIT_PULL_STATUS) {
            obj.status = (0, credit_pull_status_1.creditPullStatusToJSON)(message.status);
        }
        if (message.score !== undefined && message.score !== 0) {
            obj.score = Math.round(message.score);
        }
        if (message.scoreModel !== undefined && message.scoreModel !== score_model_1.ScoreModel.INVALID_SCORE_MODEL) {
            obj.scoreModel = (0, score_model_1.scoreModelToJSON)(message.scoreModel);
        }
        if (message.scoreFactors !== undefined) {
            obj.scoreFactors = score_factors_1.ScoreFactors.toJSON(message.scoreFactors);
        }
        if (message.simulateInternalError !== undefined && message.simulateInternalError !== false) {
            obj.simulateInternalError = message.simulateInternalError;
        }
        return obj;
    },
    create(base) {
        return exports.MockCreditPullResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMockCreditPullResponse();
        message.bureau = object.bureau ?? credit_bureau_1.CreditBureau.INVALID_CREDIT_BUREAU;
        message.status = object.status ?? credit_pull_status_1.CreditPullStatus.INVALID_CREDIT_PULL_STATUS;
        message.score = object.score ?? 0;
        message.scoreModel = object.scoreModel ?? score_model_1.ScoreModel.INVALID_SCORE_MODEL;
        message.scoreFactors = (object.scoreFactors !== undefined && object.scoreFactors !== null)
            ? score_factors_1.ScoreFactors.fromPartial(object.scoreFactors)
            : undefined;
        message.simulateInternalError = object.simulateInternalError ?? false;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=mock-credit-pull-response.js.map